<template>
  <roe-error-message :field="design.employer_match_true_up">
    <roe-radio-input
      value1="yes"
      value2="no"
      v-model="design.$model.employer_match_true_up"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
export default {
  name: "RoeEmployerMatchTrueUpRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
